<template>
  <div class="chart-data-page-content common-title-page">
    <div class="title-wrapper">
      <pods-input ref="podsInput"></pods-input>
      <span class="title">{{ $t('text.chart_pod_accelerometer') }}</span>
      <DatePicker />
    </div>
    <div class="page-content" v-loading="loading">
      <div class="mt-10 dark-font bold-font">
        {{ $t('text.recent_data_for') }}
      </div>
      <div
        id="acce-chart"
        class="mt-10"
        :style="{
          width: '100%',
          height: '400px'
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import PodsInput from '@/components/PodsInput'
import DatePicker from '@/components/DatePicker'
import $ from 'jquery'
export default {
  data() {
    return {
      chart: ''
    }
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    PodsInput,
    DatePicker
  },
  mounted: function() {
    $('#acce-chart').css('width', $('.page-content').width() + 'px')
  },
  methods: {
    initChart() {
      let vm = this
      let source = [['timeStampWithUtc', 'ax', 'ay', 'az']]
      this.$parent.$parent.$parent.source.forEach((item, index) => {
        if (index > 0) {
          source.push([item[0], item[3], item[4], item[5]])
        }
      })
      var dom = document.getElementById('acce-chart')
      this.chart = this.echarts.init(dom)
      this.chart.setOption({
        grid: {
          left: 0,
          right: 20,
          bottom: 50,
          top: 20,
          containLabel: true
        },
        tooltip: this.$parent.$parent.$parent.tooltip,
        color: ['#008ffb', '#00e396', '#feb019'],
        legend: {
          x: 'center',
          y: 'bottom',
          data: ['Ax', 'Ay', 'Az']
        },
        xAxis: [
          {
            type: 'time',
            boundaryGap: false,
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              showMinLabel: true,
              showMaxLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            nameLocation: 'center',
            axisLine: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#f2f2f2'],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        dataZoom: [
          {
            show: true,
            height: 25,
            bottom: 25,
            start: 0,
            zoomOnMouseWheel: true,
            moveOnMouseMove: true
          },
          {
            type: 'inside'
          }
        ],
        dataset: {
          dimensions: ['timeStampWithUtc', 'ax', 'ay', 'az'],
          source: source
        },
        series: [
          {
            name: 'Ax',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeStampWithUtc',
              y: 'ax'
            }
          },
          {
            name: 'Ay',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeStampWithUtc',
              y: 'ay'
            }
          },
          {
            name: 'Az',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeStampWithUtc',
              y: 'az'
            }
          }
        ]
      })
      window.addEventListener('resize', function() {
        vm.chart.resize()
      })
    }
  },
  beforeDestroy() {
    this.chart.clear()
  }
}
</script>
